// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimTransferAccountDto
 */
export interface IClaimTransferAccountDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimTransferAccountDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimTransferAccountDto
     */
    commuter_limit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimTransferAccountDto
     */
    is_locked?: boolean;
}

/**
 * Check if a given object implements the IClaimTransferAccountDto interface.
 */
export function instanceOfIClaimTransferAccountDto(value: object): value is IClaimTransferAccountDto {
    return true;
}

export function IClaimTransferAccountDtoFromJSON(json: any): IClaimTransferAccountDto {
    return IClaimTransferAccountDtoFromJSONTyped(json, false);
}

export function IClaimTransferAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimTransferAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'commuter_limit': json['commuter_limit'] == null ? undefined : json['commuter_limit'],
        'is_locked': json['is_locked'] == null ? undefined : json['is_locked'],
    };
}

export function IClaimTransferAccountDtoToJSON(json: any): IClaimTransferAccountDto {
    return IClaimTransferAccountDtoToJSONTyped(json, false);
}

export function IClaimTransferAccountDtoToJSONTyped(value?: IClaimTransferAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'amount': value['amount'],
        'commuter_limit': value['commuter_limit'],
        'is_locked': value['is_locked'],
    };
}

